import { render, staticRenderFns } from "./AdminLogovanje.vue?vue&type=template&id=2b286c7c&"
import script from "./AdminLogovanje.vue?vue&type=script&lang=js&"
export * from "./AdminLogovanje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports